module.exports = __webpack_public_path__ + "img/SoftTip.906c972a.jpg";